<template>
 <div id="layoutAuthentication" >
            <div id="layoutAuthentication_content">
                <main>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-5">
                                <div class="card shadow-lg border-0 rounded-lg mt-5">
                                    <div class="card-header"><h3 class="text-center font-weight-light my-4">Login</h3></div>
                                    <div class="card-body">
                                        <form @submit.prevent="login_user">
                                            <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Email</label>
                                                <input class="form-control py-4" id="inputEmailAddress" type="email" placeholder="Enter email address"  v-model="form.email" required/>
                                            </div>
                                            <div class="form-group"><label class="small mb-1" for="inputPassword" >Password</label>
                                                <input class="form-control py-4" id="inputPassword" type="password" placeholder="Enter password" v-model="form.password" required/>
                                            </div>
                                            <div class="form-group">
                                            </div>
                                            <p v-if="message"  class="text-center" style="color: red"> {{message}} </p>
                                            <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                                                <a class="small forgotpassword" @click="forgortPassword">Forgot Password?</a>
                                                <button type="submit" class="btn btn-primary" >Login
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </button>
                                                </div>
                                        </form>
                                    </div>
                                    <div class="card-footer text-center">
                                        <div class="small">
                                            <a href="/editor/register ">Need an account? Sign up!</a>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <div id="layoutAuthentication_footer">
                <footer class="py-4 bg-light mt-5">
                    <div class="container-fluid">
                        <div class="d-flex align-items-center justify-content-between small">
                            <div class="text-muted">Copyright &copy; ActionCommons 2020</div>
                            <div>
                                <a href="#">Privacy Policy</a>
                                &middot;
                                <a href="#">Terms &amp; Conditions</a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
</template>
<script>
import url from '../URL'

export default {
    data() {
        return {
            form : {
                email:'',
                password:'',
            },
            loading:false,
            message:'',
        }
    },
    methods:{
        forgortPassword() {
           this.$router.push(`/request_password_recovery?next=${this.$router.currentRoute.path}`)
        },
       async login_user() {
              this.loading = true
              this.message = ''
            
            const data = {
                        "email" : this.form.email,
                        "password" : this.form.password
                    }

                try {
                     const response = await this.$http.post(`${this.apiurl}/api/actioncommons/editor/login`,data)
                        if(response.status === 200) {
                            localStorage.setItem('editorToken', response.data.token)
                            this.$router.push('/editor_dashboard/home')
                            this.loadding = false;
                        }
            } catch( err) {
                    if(err.response.status === 401) {
                        this.message = err.response.data.message;
                        this.loading = false

                    } else if(err.response.status === 422) {
                        this.message = err.response.data.message;
                        this.loading = false

                    }
                     else if(err.request) {
                        this.message = "Network Error Try Again!."
                        this.loading  = false
                    }
                
            }
        
        }
    },
   computed: {
    apiurl() {
        return url()
    }, 
},
}
</script>
<style scoped>
.forgotpassword:hover{
    cursor: pointer;
    text-decoration: underline !important;
}
.forgotpassword{
    color:blue !important;

}
</style>